import i18n from "@/config/i18n.config";
import { useCurrentUser } from "@/hooks/useCurrentUser/useCurrentUser";
import { PropsWithChildren, useEffect } from "react";

import { I18nextProvider as I18nextProviderBase } from "react-i18next";

export function I18nextProvider({ children }: PropsWithChildren) {
  const { currentUser } = useCurrentUser();

  useEffect(() => {
    i18n.changeLanguage(currentUser?.language ?? "en-US");
  }, [currentUser]);

  return <I18nextProviderBase i18n={i18n}>{children}</I18nextProviderBase>;
}
